import { render, staticRenderFns } from "./yszc.vue?vue&type=template&id=705715a1&scoped=true"
import script from "./yszc.vue?vue&type=script&lang=js"
export * from "./yszc.vue?vue&type=script&lang=js"
import style0 from "./yszc.vue?vue&type=style&index=0&id=705715a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705715a1",
  null
  
)

export default component.exports